import type { CustomerSignupInput } from '../../types'

export const toSignupPayload = (input: CustomerSignupInput) => ({
  email: input.email.trim(),
  firstName: input.firstName.trim(),
  lastName: input.lastName.trim(),
  taxCode: input.taxCode.trim().toUpperCase(),
  phone: input.phone.trim(),
  residentialAddress: input.residentialAddress.trim(),
  botProtection: input.botProtection
    ? {
        providerId: input.botProtection.providerId.trim(),
        token: input.botProtection.token.trim(),
      }
    : undefined,
})

export const toLoginPayload = (input: { identifier: string; password: string }) => ({
  identifier: input.identifier.trim(),
  password: input.password,
})

export const resolveActiveToken = ({
  token,
  readStoredToken,
}: {
  token: string | null
  readStoredToken: () => string | null
}): string | null => token || readStoredToken()
